import React, { useEffect, useState, useCallback } from "react";
import { Modal, Row, Col, Button, Form } from "react-bootstrap";
import {
  eliminarSuscripcion,
  generarSuscripcion,
} from "../../../../services/suscripcionService";
import {
  GoogleReCaptchaProvider,
  withGoogleReCaptcha
} from "react-google-recaptcha-v3";

import {INFO, ALERT_ERROR, ALERT_OK } from "../../../../components/iconsSVG/IconsSVG";
import Spinner from "../../../../components/spinner/spinner"; // ajusta la ruta según donde esté
import Politica from "../politica/Politica";

// import { AlertComp } from "../alert/alertComp"
import { useAlert } from "../../../../context/AlertContext";

import { AlertRenderer } from "../../../../../src/components/alert/AlertRenderer";

function Formulario() {
  
  const [show, setShow] = useState(false);
  const [showCancelacion, setShowCancelacion] = useState(false);
  const handleClose = () => setShow(false);
  const handleCloseCancelacion = () => setShowCancelacion(false);
  const [error, setError] = useState(false);
  const [errorCorreo, setErrorCorreo] = useState("");
  const [errorNombre, setErrorNombre] = useState("");
  const [errorApellidos, setErrorApellidos] = useState("");
  const [errorSuscripcion, setErrorSuscripcion] = useState("");
  const [errorRazon, setErrorRazon] = useState("");
  const [errorCargo, setErrorCargo] = useState("");
  

  const [tipoPersona, setTipoPersona] = useState("");
  const [razon, setRazon] = useState("");
  const [correo, setCorreo] = useState("");
  const [nombre, setNombre] = useState("");
  const [apellidos, setApellidos] = useState("");
  const [cargo, setCargo] = useState("");
  const [tipoSuscripciones, setTipoSuscripciones] = useState([
    false,
    false,
    false,
  ]);
  const [correoBaja, setCorreoBaja] = useState("");

  const controlId = false;

  // const [mostrarAlert, setmostrarAlert] = useState(false);
  const mostrarScroll = () => {
    setTimeout(() => {
      window.scrollTo(0, 0);  // Scroll inmediato después de 100ms
    }, 100);
  };

  const [msg, setMsg] = useState("OpNok");
  

  // const handleCloseAlert = () => {
  //   setmostrarAlert(false);
  //   closeAlert();
  // };

  // se obtienen las funciones para alerta del contexto:
  const { showAlert } = useAlert();
  const { closeAlert } = useAlert();
  

  const handleSelectChange = (e) => {
    setTipoPersona(e.target.value);
  };

  const handleRazonChange = (e) => {
    setRazon(e.target.value);
    if (errorRazon && e.target.value) {
      setErrorRazon('');
    }
  };

  const handleCorreoChange = (e) => {
    setCorreo(e.target.value);
    if (errorCorreo && e.target.value) {
      setErrorCorreo('');
    }
  };

  const handleNombreChange = (e) => {
    setNombre(e.target.value);
    if (errorNombre && e.target.value) {
      setErrorNombre('');
    }
  };

  const handleApellidosChange = (e) => {
    setApellidos(e.target.value);
    if (errorApellidos && e.target.value) {
      setErrorApellidos('');
    }
  };

  const handleCargoChange = (e) => {
    setCargo(e.target.value);
    if (errorCargo && e.target.value) {
      setErrorCargo('');
    }
  };


  const handleCheckboxChange = (index) => {
    const newSuscripciones = tipoSuscripciones.map((value, i) => {
      if (i === index) {
        return !value;
      }
      return value;
    });
    setTipoSuscripciones(newSuscripciones);
    if (errorSuscripcion && newSuscripciones.includes(true)) setErrorSuscripcion('');
  };

  const handleCorreoBajaChange = (e) => {
    setCorreoBaja(e.target.value);
  };

  const handleSuscription = async (e) => {

    setIsWaiting(true);
    mostrarScroll();

    await new Promise(resolve => {
      setTimeout(resolve, 500);  // ✅ Espera 0,5s y continúa
    });

    e.preventDefault();
    let hasErrors = false;
    
    if (!correo.trim()) {
      setErrorCorreo('El campo "Correo" es obligatorio.');
      hasErrors = true;
    }
    if (!nombre.trim()) {
      setErrorNombre('El campo "Nombre" es obligatorio.');
      hasErrors = true;
    }
    if (!apellidos.trim()) {
      setErrorApellidos('El campo "Apellidos" es obligatorio.');
      hasErrors = true;
    }
    if (!tipoSuscripciones.includes(true)) {
      setErrorSuscripcion('Debes seleccionar al menos una opción de suscripción.');
      hasErrors = true;
    }

    if (tipoPersona === "juridica") {
      if (!razon.trim()) {
        setErrorRazon('El campo "Razón social" es obligatorio para personas jurídicas.');
        hasErrors = true;
      }
      if (!cargo.trim()) {
        setErrorCargo('El campo "Cargo" es obligatorio para personas jurídicas.');
        hasErrors = true;
      }
    }
    
    if (hasErrors) {
      setIsWaiting(false); 
      return;
    }

    try {      
      const respuesta = await generarSuscripcion(
        tipoPersona,
        razon,
        correo,
        nombre,
        apellidos,
        cargo,
        tipoSuscripciones
      );

      
      // // --> PRUEBA API REST (descomentar esto y comentar el equivalente de arriba):
      // const respuesta = await generarSuscripcion( );
      // // FIN PRUEBA API REST  <--
      
      // // setmostrarAlert(false);
      // setmostrarAlert(true);

      

      
      let mensaje = `
      Suscripción correcta.
      `;

      setMsg("OpOk");   

      showAlert({
        tipo: "success",
        titulo: "Éxito",
        msg: mensaje ,
        customIcon: <ALERT_OK/>

        
      });
    

      //alert("Se ha obtenido JSON desde BD correctamente, " + JSON.stringify(respuesta, null, 2));
    } catch (error) {
      console.error("Error al suscribirse:", error);
      //setShow(true);
      // setTipo("error");
      // setTitulo("Error");

      let mensaje =((error.toString().split("Error: ")[2] == "" || error.toString().split("Error: ")[2] == null)
      ? "Lo sentimos, ha ocurrido un error inesperado. Por favor, inténtalo de nuevo pasados unos minutos. Si el problema persiste, contacta con soportefuncional@oepm.es."
      : error.toString().split("Error: ")[2]);

      setMsg("OpNok");        
      
      showAlert({
        tipo: "error",
        titulo: "Error",
        msg: mensaje,
        customIcon: <ALERT_ERROR/>
      });

      //console.error("Ocurrió un error al suscribirse:", error);
    } finally {
      setIsWaiting(false);  // SIEMPRE se ejecuta
      // setmostrarAlert(true);
    }
  };  

  const [errorMessage, setErrorMessage] = useState("");

const handleUnsuscribe = async (e) => {
  e.preventDefault();
  setIsWaiting(true);
  mostrarScroll();

  await new Promise(resolve => {
    setTimeout(resolve, 500);  // ✅ Espera 0,5s y continúa
  });

  try {
    //if (correoBaja.trim() !== "") {
      await eliminarSuscripcion(correoBaja);
      
      let mensaje = `
      Se ha enviado un correo de verificación a la dirección indicada.
      `;
      setMsg("OpOk");

      showAlert({
        tipo: "success",
        titulo: "Éxito",
        msg: mensaje,
        customIcon: <ALERT_OK/>
      });
      //alert(`Suscripción con correo ${correoBaja} eliminada correctamente.`);

   // }
  } catch (error) {  
      let mensaje =((error.toString().split("Error: ")[2] == "" || error.toString().split("Error: ")[2] == null)
      ? "Lo sentimos, ha ocurrido un error inesperado. Por favor, inténtalo de nuevo pasados unos minutos. Si el problema persiste, contacta con soportefuncional@oepm.es."
      : error.toString().split("Error: ")[2]);

      setMsg("OpNok");

      // setCustomicon(<ALERT_ERROR/>)
      // setmostrarAlert(false);
      // setmostrarAlert(true);      
      if (!mensaje) return; // no disparar si está vacío
      showAlert({
        tipo: "error",
        titulo: "Error",
        msg: mensaje,
        customIcon: <ALERT_ERROR/>
      });

      console.error(error.toString().split("Error: ")[2]);
  } finally {
    setIsWaiting(false);  // SIEMPRE se ejecuta
    setIsWaiting(false);
    
  }
};


  const handleLimpiar = () => {
    setTipoPersona("");
    setCorreo("");
    setNombre("");
    setApellidos("");
    setTipoSuscripciones([false, false, false]);
    setCorreoBaja('');

    setErrorCorreo('');
    setErrorNombre('');
    setErrorApellidos('');
    setErrorSuscripcion('');
    setErrorRazon('');
    setErrorCargo('');
  
    setIsWaiting(false);

    setMsg("OpNok");        
    // setmostrarAlert(false);
    
    closeAlert();
    setcheckBoxConditions([false]);
  };


  const [checkBoxConditions, setcheckBoxConditions] = useState([false]);

  const handleCheckboxChangeConditions = (index) => {
    const newcheckBoxConditions = checkBoxConditions.map((value, i) => {
      if (i === index) {
        return !value;
      }
      return value;
    });    

    if (!checkBoxConditions[0]) {
      window.open("https://sede.oepm.gob.es/eSede/datos/es/aviso_legal.html", "_blank")
    };

    setcheckBoxConditions(newcheckBoxConditions);
  };

  const [IsWaiting, setIsWaiting] = useState(false);

  return (        
    <Form>

      {/* ESTO ES PARA MOSTRAR LA ALERTA */}
      <AlertRenderer />

      {/* {mostrarAlert && (
          <AlertComp 
            tipo={tipo} 
            titulo={titulo} 
            msg={msg} 
            customIcon={customIcon}   
            open={mostrarAlert}
            onClose={handleCloseAlert}
          />
        )
      } */}
      {IsWaiting && (
        <div className="text-center p-3">
          <Spinner message="Gestionando suscripción ..." />
        </div>
      )
      }
      {/* cuando la suscripción o baja es correcta, solo muestro el mensaje y no muestro el resto de controles, como han solicitado */}
      {!(msg === "OpOk") ? (
        <div>
          <p>
            Para poder recibir por correo electrónico los tomos del Boletín Oficial
            de la Propiedad Industrial en formato PDF, necesitamos algunos datos
            personales:
          </p>
          <Row>
            <Col xs={12} lg={7}>
              <Form.Group className="mb-3" controlId="formBasicTipo">
                <Form.Label>
                  <b>Tipo </b>(requerido)
                </Form.Label>
                <Form.Select
                  aria-label="Default select example"
                  onChange={handleSelectChange}
                >
                  <option value="fisica">Persona física</option>
                  <option value="juridica">Empresa u Organización - Persona jurídica</option>
                </Form.Select>
              </Form.Group>

              {tipoPersona === "juridica" && (
                <Form.Group className="mb-3" controlId="razonSocial">
                  <Form.Label>
                    <b>Razón social</b> (requerido)
                  </Form.Label>
                  <Form.Control
                    type="razon"
                    value={razon}
                    onChange={handleRazonChange}
                    isInvalid={!!errorRazon}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errorRazon}
                  </Form.Control.Feedback>
                </Form.Group>
              )}

              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  <b>Correo electrónico</b> (requerido)
                </Form.Label>
                <Form.Control
                  type="email"
                  value={correo}
                  onChange={handleCorreoChange}
                  isInvalid={!!errorCorreo}
                />
                <Form.Control.Feedback type="invalid">
                  {errorCorreo}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicNombre">
                <Form.Label>
                  <b>Nombre</b> (requerido)
                </Form.Label>
                <Form.Control
                  type="nombre"
                  value={nombre}
                  onChange={handleNombreChange}
                  isInvalid={!!errorNombre}
                />
                <Form.Control.Feedback type="invalid">
                  {errorNombre}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicApellidos">
                <Form.Label>
                  <b>Apellidos</b> (requerido)
                </Form.Label>
                <Form.Control
                  type="apellidos"
                  value={apellidos}
                  onChange={handleApellidosChange}
                  isInvalid={!!errorApellidos}
                />
                <Form.Control.Feedback type="invalid">
                  {errorApellidos}
                </Form.Control.Feedback>
              </Form.Group>

              {tipoPersona === "juridica" && (
                <Form.Group className="mb-3" controlId="Cargo">
                  <Form.Label>
                    <b>Cargo</b> (requerido)
                  </Form.Label>
                  <Form.Control
                    type="cargo"
                    value={cargo}
                    onChange={handleCargoChange}
                    isInvalid={!!errorCargo}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errorCargo}
                  </Form.Control.Feedback>
                </Form.Group>
              )}

            </Col>
            <Col xs={12} lg={5}></Col>

          </Row>

          <Form.Label>
            <b>Suscribirse a:</b> (requerido)
          </Form.Label>
          <div className="mb-3">
            <Form.Check
              type="checkbox"
              id="tomo1"
              label="TOMO 1: Marcas y otros signos distintivos"
              checked={tipoSuscripciones[0]}
              onChange={() => handleCheckboxChange(0)}
            />
            <Form.Check
              type="checkbox"
              id="tomo2"
              label="TOMO 2: Invenciones"
              checked={tipoSuscripciones[1]}
              onChange={() => handleCheckboxChange(1)}
            />
            <Form.Check
              type="checkbox"
              id="tomo3"
              label="TOMO 3: Diseños industriales"
              checked={tipoSuscripciones[2]}
              onChange={() => handleCheckboxChange(2)}
            />
            {errorSuscripcion && <div className="text-danger">{errorSuscripcion}</div>}
          </div>

          <Form.Group controlId="formCheckbox">
            <Form.Check
              type="checkbox"
              checked={checkBoxConditions[0]}
              onChange={() => handleCheckboxChangeConditions(0)}
              label={
                <>
                  He leído y acepto las{" "}
                  <a href="https://sede.oepm.gob.es/eSede/datos/es/aviso_legal.html">
                    condiciones
                  </a>{" "}
                  del uso de datos reutilizables, en particular las referentes a
                  tratamiento de datos personales.
                </>
              }
            />
          </Form.Group>
          <br />
          <Row className="p-0 m-0 gap-3">
            <Col xs="auto" className="d-flex justify-content-center p-0 m-0 mb-1 mb-lg-0 ">
              <Button disabled={!checkBoxConditions[0]}
                type="button"
                className="btn btn-azul w-100" onClick={handleSuscription} >
                SUSCRIBIRME
              </Button>
            </Col>
            <Col xs="auto" className="d-flex justify-content-center p-0 m-0 mb-1 mb-lg-0">
              <Button type="reset" className="btn btn-blue-border w-100" onClick={handleLimpiar}>
                LIMPIAR
              </Button>
            </Col>
            <Col></Col>
          </Row>
          <br />
          <br />

          <h2 style={{ fontSize: '1.5em' }}>Quiero darme de baja</h2>
          <p>
            Si desea darse de baja introduzca su dirección de correo electrónico:
          </p>
          {/* <div className="alinear"> */}
          <Row className="p-0 m-0 align-items-center gap-3 ">
            <Col xs={12} md={4} className="p-0 m-0">
              <Form.Control
                placeholder="Email"
                type="email"
                value={correoBaja}
                onChange={handleCorreoBajaChange}
              />
            </Col>
            <Col xs="auto" className="p-0 d-flex justify-content-start m-0 mb-1 mb-lg-0">
              <Button
                className="btn btn-blue-border w-100"
                type="submit"
                onClick={handleUnsuscribe}
              >
                CANCELAR SUSCRIPCIÓN
              </Button>
            </Col>
          </Row>
          {/* </div> */}
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              Se ha producido un error al suscribirse.
            </Modal.Body>
          </Modal>
          <Modal show={showCancelacion} onHide={handleCloseCancelacion}>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              Se ha producido un error al dar de baja el correo.
            </Modal.Body>
          </Modal>

          <br />
          <br />
          <Politica />
          <br />
          <br />

        </div>)
        :
        (<div></div>)
      }
    </Form>
    
  );
}

const MyApp = ({ googleReCaptchaProps }) => {
  const [token, setToken] = useState(null);
  const getToken = useCallback(async () => {
    const _token = await googleReCaptchaProps.executeRecaptcha("bopiweb2");
    setToken(_token);
  }, [googleReCaptchaProps]);
  useEffect(() => {
    getToken();
  }, [getToken]);
};
const MyAppp = withGoogleReCaptcha(MyApp);

// export default Formulario;

export default function App() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LcPJLorAAAAANHYQH5aZ0G_OIsmYIXQhr1jPIv9">
      <Formulario />
    </GoogleReCaptchaProvider>
  );
}